module.exports = __webpack_public_path__ + "img/del-input-ques.7b7a3ae0.svg";